import { DrawerSettingsType } from "features/Drawer/types/types";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import { Suspense, lazy } from "react";

const BookButtonOpen = lazy(() => import("../BookButtonOpen"));

export default function BookButtonDrawer({
  bookId,
  referrerUserId,
  settings,
}: {
  bookId: number;
  referrerUserId?: number;
  settings: DrawerSettingsType;
}) {
  const currentUserId = useCurrentUserId();

  // Never load or show the Book Button Drawer when not logged in
  if (!currentUserId) {
    return <></>;
  }

  return (
    <Suspense>
      <BookButtonOpen bookId={bookId} referrerUserId={referrerUserId} settings={settings} />
    </Suspense>
  );
}
